import { SpaceType } from "@components/atoms/Spacer/types";
import React from "react";
import styled, { DefaultTheme } from "styled-components/native";
import { DefaultThemeValueType } from "../../../../styled";

type LineViewProps = {
  background: DefaultThemeValueType;
  marginLeft?: boolean;
  marginRight?: boolean;
  height?: boolean;
  flexDirection?: string;
};

const LineViewContainer = ({
  background,
  marginLeft,
  marginRight,
  height,
  flexDirection,
}: LineViewProps) => {
  return (
    <LineView
      background={background}
      marginRight={marginRight}
      marginLeft={marginLeft}
      height={height}
      flexDirection={flexDirection}
    />
  );
};
const LineView = styled.View<{
  background: DefaultThemeValueType;
  marginLeft?: boolean;
  marginRight?: boolean;
  height?: boolean;
  flexDirection?: string;
}>`
  height: ${({ height }) => (height ? "100%" : "1px")};
  flex-direction: ${({ flexDirection }) =>
    flexDirection ? flexDirection : "row"};
  background-color: ${({ theme, background }) =>
    theme[(background as keyof DefaultTheme) || "core-03"] as string};
  margin-left: ${({ marginLeft }) => (marginLeft ? SpaceType.Double : 0)}px;
  margin-right: ${({ marginRight }) => (marginRight ? SpaceType.Double : 0)}px;
`;

export default LineViewContainer;
